import styled from '@emotion/styled';
import Media from '@ep/components/Media';
import { Body } from '@ep/templates/ProductPage';
import theme from '@ep/theme';
import { Gcms_TabPost } from '@ep/types/gatsbyTypes';
import getHtmlProp from '@ep/utils/getHtmlProp';
import Box from '@mui/material/Box';
import React from 'react';

export interface TabPostCardProps {
  tabPost: Gcms_TabPost;
}

const StyledMedia = styled(Media)`
  float: left;
  width: 40rem;
  height: 28rem;
  :before {
    padding-bottom: 0rem;
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 1050}px) {
    width: 38rem;
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 950}px) {
    margin-left: 2rem;
    width: 32rem;
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 700}px) {
    float: none;
    width: 38rem;
    height: 22rem;
    margin: auto 20%;
    margin-top: 4rem;
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 480}px) {
    height: 17rem;
    width: 60%;
  }
  ${theme.mediaQueries.mobile} {
    margin: auto 10%;
    width: 75%;
  }
`;

const HeadingContainer = styled.div`
  margin-top: 5rem;
  ${theme.mediaQueries.mobile} {
    margin-top: 1rem;
  }
  margin-bottom: 2rem;
`;

const Texts = styled('div')`
  width: 46%;
  float: right;
  @media (max-width: ${theme.breakpoints.optimalMobile + 950}px) {
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 700}px) {
    margin: auto auto;
    float: none;
  }
  ${theme.mediaQueries.mobile} {
    float: none;
    width: 83%;
    height: 18rem;
  }
`;

const Title = styled.h3`
  font-family: 'ProximaNovaSemiBold', 'Avenir Next', 'Helvetica Neue',
    'Segoe UI', 'Helvetica', 'Arial', sans-serif;
  font-size: 2.625rem;
  line-height: 48px;
  color: ${theme.colors.duskBlue};
  ${theme.mediaQueries.tablet} {
    line-height: 32px;
    font-size: 2rem;
  }
  ${theme.mediaQueries.mobile} {
    line-height: 35px;
    font-size: 1.8rem;
  }
  `;

const StyledCard = styled(Box)`
  background-color: ${theme.colors.lightGray};
  margin: 0rem;
  padding: 0rem;
  @media (max-width: ${theme.breakpoints.optimalMobile + 400}px) {
    margin-top: 0rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 950}px) {
  }
`;

const WindowWidth = typeof window !== 'undefined' ? window.screen.width : 800;

const TabPostCard = ({ tabPost }: TabPostCardProps) => {
  return (
    <StyledCard>
      {tabPost.image && (
        <StyledMedia
          media={
            tabPost.mobileImage
              ? WindowWidth > theme.breakpoints.desktop
                ? tabPost.image!
                : tabPost.mobileImage!
              : tabPost.image!
          }
          aspectRatio={1}
          lazy
        />
      )}
      <Texts>
        <HeadingContainer>
          {tabPost.heading && <Title>{tabPost.heading}</Title>}
        </HeadingContainer>
        {tabPost.description && (
          <Body {...getHtmlProp(tabPost.description.html)} />
        )}
      </Texts>
    </StyledCard>
  );
};

export default TabPostCard;
